import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _pt from "prop-types";
import React, { useState, useEffect } from 'react';
import * as Styled from './InputRange.styles';

var calculateTrackPercentage = function calculateTrackPercentage(value, options) {
  return value * 100 / (options.length - 1);
};

var InputRange = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$label = _ref.label,
      label = _ref$label === void 0 ? '' : _ref$label,
      _ref$labelHidden = _ref.labelHidden,
      labelHidden = _ref$labelHidden === void 0 ? false : _ref$labelHidden,
      _ref$name = _ref.name,
      name = _ref$name === void 0 ? 'range' : _ref$name,
      _ref$optional = _ref.optional,
      optional = _ref$optional === void 0 ? '' : _ref$optional,
      _ref$options = _ref.options,
      options = _ref$options === void 0 ? [{
    value: 0,
    label: ''
  }, {
    value: 1,
    label: ''
  }, {
    value: 2,
    label: ''
  }, {
    value: 3,
    label: ''
  }, {
    value: 4,
    label: ''
  }] : _ref$options,
      _ref$tickMarksLabelsA = _ref.tickMarksLabelsAbove,
      tickMarksLabelsAbove = _ref$tickMarksLabelsA === void 0 ? false : _ref$tickMarksLabelsA,
      onChange = _ref.onChange,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? 0 : _ref$value,
      _ref$dataTest = _ref['data-test'],
      dataTest = _ref$dataTest === void 0 ? 'input-range' : _ref$dataTest;

  var _useState = useState(value),
      _useState2 = _slicedToArray(_useState, 2),
      inputValue = _useState2[0],
      setInputValue = _useState2[1];

  var _useState3 = useState(calculateTrackPercentage(value, options)),
      _useState4 = _slicedToArray(_useState3, 2),
      trackValue = _useState4[0],
      setTrackValue = _useState4[1];

  useEffect(function () {
    setTrackValue(calculateTrackPercentage(value, options));
    setInputValue(value);
  }, [value]);

  var handleChange = function handleChange(event) {
    setInputValue(event.target.value);
    setTrackValue(calculateTrackPercentage(event.target.value, options));

    if (onChange) {
      onChange(event);
    }
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, label && /*#__PURE__*/React.createElement(Styled.Label, {
    className: labelHidden ? 'sr-only' : null,
    id: "".concat(dataTest, "-").concat(name, "-label"),
    htmlFor: name
  }, label, optional && /*#__PURE__*/React.createElement(Styled.OptionalLabel, null, optional)), tickMarksLabelsAbove && /*#__PURE__*/React.createElement(Styled.TickMarksLabelsContainer, null, options.map(function (option) {
    return /*#__PURE__*/React.createElement(Styled.TickMarkLabel, {
      key: option.label
    }, option.label);
  })), /*#__PURE__*/React.createElement(Styled.Input, {
    type: "range",
    id: name,
    name: name,
    max: options.length - 1,
    list: "".concat(name, "-tickmarks"),
    onChange: handleChange,
    value: inputValue,
    trackValue: trackValue,
    "data-test": dataTest,
    "aria-valuemin": "0",
    "aria-valuemax": options.length - 1,
    "aria-valuenow": value,
    ref: ref
  }), /*#__PURE__*/React.createElement(Styled.Datalist, {
    id: "".concat(name, "-tickmarks"),
    "data-test": "".concat(dataTest, "-tickmarks")
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement(Styled.Option, {
      key: option.value,
      value: option.value,
      label: option.label,
      tickMarksLabelsAbove: tickMarksLabelsAbove
    });
  })));
});
InputRange.propTypes = {
  label: _pt.string,
  labelHidden: _pt.bool,
  name: _pt.string,
  optional: _pt.string,
  options: _pt.arrayOf(_pt.shape({
    value: _pt.number.isRequired,
    label: _pt.string
  })),
  tickMarksLabelsAbove: _pt.bool,
  onChange: _pt.func,
  value: _pt.number,
  'data-test': _pt.string
};
InputRange.displayName = 'InputRange';
export default InputRange;